// extracted by mini-css-extract-plugin
export default {"CommentsButton":"ij_a bhb_vr bhb_iv bhb_wf bhb_i bhb_j bhb_q bhb_un bhb_en bhb_ri bhb_rj bhb_cx","CommentsButton__icon":"ij_b bhb_re"};